import React, { useEffect, useState } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation
} from 'react-router-dom'
import { Layout } from 'antd'
import 'antd/dist/reset.css'
import './App.css'
import { hasPermission } from './config-func'

import LoginPage from './pages/LoginPage'
import RoleManagement from './pages/RoleManagement'
import UserManagement from './pages/UserManagement'
import DepartmentManagement from './pages/DepartmentManagement'
import PostManagement from './pages/PostManagement'
import ProjectManagement from './pages/ProjectManagement'
// import { logout } from './services/bondservice'
import { Toaster } from 'react-hot-toast'
import Sidebar from './components/Sidebar/Sidebar'
import Header from './components/Header'
import { logout } from './services/cmsservice'
import ProjectRecommendManagement from './pages/ProjectRecommendManagement'
import DynamicTitle from './DynamicTitle'
import DashBoard from './components/Dashboard'
import RequestInternalPage from './pages/RequestInternalManagement'
import ProjectRecommendRegisterPage from './pages/ProjectRecommendRegister'
import SystemManagementPage from './pages/SystemManagement'
import NotificationManagementPage from './pages/NotificationManagement'
import PakageCommunityPage from './pages/PakageCommunityPage'
import PakageCommunityHistoryPage from './pages/PakageCommunityHistoryPage'
import ConfigurationPakagePostPage from './pages/ConfigurationPakagePostPage'
import ConfigPostHistoryPage from './pages/ConfigPostHistoryPage'
import ManagerPostWebPage from './pages/ManagerPostWeb'
import FooterManagementPage from './pages/FooterManagementPage'
import RechargePromotionsHistoryPage from './pages/RechargePromotionsHistoryPage'
import RechargePromotions from './components/RechargePromotions/RechargePromotions'
import PostCommunityManagementPage from './pages/PostCommunityManagementPage'
import AuctionViewHistoryPage from './pages/AuctionViewHistoryPage'
import SlideImagePage from './pages/SlideImagePage'
import CenterInfoPage from './pages/CenterInfoPage'
import ImessManagementPage from './pages/ImessManagement'
import DuplicatePostManagementPage from './pages/DuplicatePostManagement'
import DuplicatePostCommunityManagementPage from './pages/DuplicatePostCommunityManagement'
import WebFeeManagementPage from './pages/WebFeeManagementPage'
import ServiceManagementPage from './pages/ServiceManagementPage'
import LandingPage from './components/Landing/Landing'
import InfoSecurityPolicy from './components/Landing/InfoSecurityPolicy'
import TermsOfAgreement from './components/Landing/TermsOfAgreement'
import ComplaintResolution from './components/Landing/ComplaintResolution'
import OperatingRegulations from './components/Landing/OperatingRegulations'
import GeneralProvisions from './components/Landing/GeneralProvisions'
import MainLayout from './MainLayout'
import NotFoundPage from './NotFoundPage'
import ManagementRecruitmentPage from './pages/ManagementRecruitmentPage'
import BreakingNewsPage from './pages/BreakingNewsPage'
import SelectionManagementPage from './pages/SelectionManagementPage'
import DataCustomerManagementPage from './pages/DataCustomerManagementPage'
import PageAccountManagementWeb from './pages/AccountManagementWeb'
import ManagerRequestPostWeb from './components/ManagerRequestPostWeb/ManagerRequestPostWeb'
import { APP_VERSION, APP_VERSION_LABEL } from './configs/version'
import VersionChecker from './components/VersionChecker'
import BookingManagementPage from './pages/BookingManagementPage'

const { Content } = Layout

const App = () => {
  const [isCollapsed, setIsCollapsed] = useState(
    localStorage.getItem('isCollaped') === 'true' ? true : false
  )
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem('access_token')
  )

  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const user_role = localStorage.getItem('user_role')

  useEffect(() => {
    window.__APP_VERSION__ = APP_VERSION
    document.documentElement.setAttribute('data-app-version', APP_VERSION_LABEL)
  }, [])

  // const [userPermissions, setUserPermissions] = useState([])
  // const [userRole, setUserRole] = useState('')

  // useEffect(() => {
  //   // Lấy danh sách quyền từ localStorage hoặc context
  //   const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  //   const user_role = localStorage.getItem('user_role')
  //   setUserPermissions(permissions)
  //   setUserRole(user_role)
  // }, [])

  const onLogout = () => {
    logout().then((res) => {
      if (res && res.data) {
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('user_name')
        localStorage.removeItem('user_phone')
        localStorage.removeItem('user_email')
        localStorage.removeItem('user_role')
        localStorage.removeItem('department_id')
        localStorage.removeItem('permissions')
        window.location.href = '/'
        setIsLoggedIn(false)
      }
    })
  }

  // Hàm kiểm tra quyền truy cập
  const checkPermission = (permission) => {
    if (user_role === 'ADMIN') {
      return true
    }
    return hasPermission(permission, permissions)
  }

  // if (!isLoggedIn && !publicPaths.includes(location.pathname)) {
  //   return <LoginPage onLogin={() => setIsLoggedIn(true)} />;
  // }
  // <Route path="/login" element={<LoginPage onLogin={() => setIsLoggedIn(true)} />} />

  const publicRoutes = [
    { path: '/terms-of-service', element: <LandingPage /> },
    { path: '/information-security-policy', element: <InfoSecurityPolicy /> },
    { path: '/terms-of-agreement', element: <TermsOfAgreement /> },
    { path: '/complaint-resolution', element: <ComplaintResolution /> },
    { path: '/operating-regulations', element: <OperatingRegulations /> },
    { path: '/general-provisions', element: <GeneralProvisions /> }
  ]
  return (
    <>
      <Toaster />
      <DynamicTitle />
      <VersionChecker />
      <Routes>
        {publicRoutes?.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
        {/* Nếu chưa login, redirect toàn bộ route khác về login */}
        {!isLoggedIn && (
          <Route
            path="*"
            element={<LoginPage onLogin={() => setIsLoggedIn(true)} />}
          />
        )}
        {isLoggedIn && (
          <Route
            path="/"
            element={
              <MainLayout
                isCollapsed={isCollapsed}
                setIsCollapsed={setIsCollapsed}
                onLogout={onLogout}
              />
            }
          >
            {checkPermission('P35') ? (
              <Route path="/" element={<DashBoard />} />
            ) : (
              <Route
                path="/"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P36') ? (
              <Route
                path="/system-manager"
                element={<SystemManagementPage />}
              />
            ) : (
              <Route
                path="/system-manager"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P37') ? (
              <Route path="/post-management" element={<PostManagement />} />
            ) : (
              <Route
                path="/post-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P38') ? (
              <Route
                path="/request-internal-management"
                element={<RequestInternalPage />}
              />
            ) : (
              <Route
                path="/request-internal-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P39') ? (
              <Route
                path="/post-community-management"
                element={<PostCommunityManagementPage />}
              />
            ) : (
              <Route
                path="/post-community-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P40') ? (
              <Route path="/role-management" element={<RoleManagement />} />
            ) : (
              <Route
                path="/role-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P41') ? (
              <Route
                path="/department-management"
                element={<DepartmentManagement />}
              />
            ) : (
              <Route
                path="/department-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P42') ? (
              <Route path="/user-management" element={<UserManagement />} />
            ) : (
              <Route
                path="/user-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P43') ? (
              <Route
                path="/project-management"
                element={<ProjectManagement />}
              />
            ) : (
              <Route
                path="/project-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P44') ? (
              <Route
                path="/project-recommend-management"
                element={<ProjectRecommendManagement />}
              />
            ) : (
              <Route
                path="/project-recommend-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P45') ? (
              <Route
                path="/notification-management"
                element={<NotificationManagementPage />}
              />
            ) : (
              <Route
                path="/notification-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P49') ? (
              <Route
                path="/auction-and-view-history"
                element={<AuctionViewHistoryPage />}
              />
            ) : (
              <Route
                path="/auction-and-view-history"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P47') ? (
              <Route
                path="/project-recommend-register"
                element={<ProjectRecommendRegisterPage />}
              />
            ) : (
              <Route
                path="/project-recommend-register"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P51') ? (
              <Route
                path="/recharge-packages-promotions"
                element={<RechargePromotions />}
              />
            ) : (
              <Route
                path="/recharge-packages-promotions"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P52') ? (
              <Route
                path="/recharge-packages-promotions-history"
                element={<RechargePromotionsHistoryPage />}
              />
            ) : (
              <Route
                path="/recharge-packages-promotions-history"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P53') ? (
              <Route
                path="/community-pakage"
                element={<PakageCommunityPage />}
              />
            ) : (
              <Route
                path="/community-pakage"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P54') ? (
              <Route
                path="/community-pakage-history"
                element={<PakageCommunityHistoryPage />}
              />
            ) : (
              <Route
                path="/community-pakage-history"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}
            {/* 
            {checkPermission('P55') ? (
              <Route
                path="/configuration-pakage-post"
                element={<ConfigurationPakagePostPage />}
              />
            ) : (
              <Route
                path="/configuration-pakage-post"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )} */}

            {checkPermission('P56') ? (
              <Route
                path="/history-pakage-post"
                element={<ConfigPostHistoryPage />}
              />
            ) : (
              <Route
                path="/history-pakage-post"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P57') ? (
              <Route
                path="/manager-post-web"
                element={<ManagerPostWebPage />}
              />
            ) : (
              <Route
                path="/manager-post-web"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}
            {checkPermission('P85') ? (
              <Route
                path="/manager-request-post-web"
                element={<ManagerRequestPostWeb />}
              />
            ) : (
              <Route
                path="/manager-request-post-web"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}
            {checkPermission('P58') ? (
              <Route path="/manager-payment-gateway" element={''} />
            ) : (
              <Route
                path="/manager-payment-gateway"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P59') ? (
              <Route
                path="/manager-footer"
                element={<FooterManagementPage />}
              />
            ) : (
              <Route
                path="/manager-footer"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}
            {checkPermission('P60') ? (
              <Route path="/manager-imess" element={<ImessManagementPage />} />
            ) : (
              <Route
                path="/manager-imess"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P61') ? (
              <Route path="/manager-slide" element={<SlideImagePage />} />
            ) : (
              <Route
                path="/manager-slide"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P62') ? (
              <Route path="/center-info" element={<CenterInfoPage />} />
            ) : (
              <Route
                path="/center-info"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P76') ? (
              <Route
                path="/duplicate-post-management"
                element={<DuplicatePostManagementPage />}
              />
            ) : (
              <Route
                path="/duplicate-post-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}
            {/* {checkPermission('P77') ? (
              <Route
                path="/duplicate-post-community-management"
                element={<DuplicatePostCommunityManagementPage />}
              />
            ) : (
              <Route
                path="/duplicate-post-community-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )} */}

            {checkPermission('P82') ? (
              <Route
                path="/web-fee-management"
                element={<WebFeeManagementPage />}
              />
            ) : (
              <Route
                path="/web-fee-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P83') ? (
              <Route
                path="/service-management"
                element={<ServiceManagementPage />}
              />
            ) : (
              <Route
                path="/service-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {/* {checkPermission('P82') ? (
              <Route
                path="/web-fee-management"
                element={<WebFeeManagementPage />}
              />
            ) : (
              <Route
                path="/web-fee-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )} */}

            {checkPermission('P78') ? (
              <Route
                path="/management-recruitment"
                element={<ManagementRecruitmentPage />}
              />
            ) : (
              <Route
                path="/management-recruitment"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P79') ? (
              <Route path="/breaking-news" element={<BreakingNewsPage />} />
            ) : (
              <Route
                path="/breaking-news"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}
            {checkPermission('P80') ? (
              <Route
                path="/selection-management"
                element={<SelectionManagementPage />}
              />
            ) : (
              <Route
                path="/selection-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}
            {checkPermission('P81') ? (
              <Route
                path="/data-customer-management"
                element={<DataCustomerManagementPage />}
              />
            ) : (
              <Route
                path="/data-customer-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}

            {checkPermission('P84') ? (
              <Route
                path="/account-web-management"
                element={<PageAccountManagementWeb />}
              />
            ) : (
              <Route
                path="/account-web-management"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}
            {checkPermission('P86') ? (
              <Route
                path="/management-booking"
                element={<BookingManagementPage />}
              />
            ) : (
              <Route
                path="/management-booking"
                element={<>Bạn không có quyền truy cập vào trang này</>}
              />
            )}
            {/* </Routes>
          </Content>
        </Layout>
      </Layout>
    </Router> */}
          </Route>
        )}
        <Route
          path="*"
          element={
            <>
              <NotFoundPage />
            </>
          }
        />
      </Routes>
      <div className="app-version-badge">{APP_VERSION_LABEL}</div>
    </>
  )
}

export default App
